import React from 'react'
import { Table, Tag } from 'antd';
import './Medication.scss'
import { withData } from '../withData'
import _ from 'lodash'
import moment from 'moment'
import { Helmet } from 'react-helmet'

const columns = [{
  title: 'ชื่อโดสยา',
  dataIndex: 'doseName',
  key: 'doseName'
}, {
  title: 'เวลาที่เตือน',
  dataIndex: 'remindAt',
  key: 'remindAt'
}, {
  title: 'สถานะ',
  dataIndex: 'eaten',
  render: (text, record) => (
    <Tag color={record.eaten ? '#108ee9' : '#f50'}>
      {record.eaten ? 'กินแล้ว' : 'ไม่ได้กิน'}
    </Tag>
  )
}];

const query = `
  query {
    medications() {
      medications {
        dose {
          name
        },
        reminder {
          remindAt
        },
        eaten
      },
      displayName,
      displayImage,
      patient {
        id,
        firstname,
        lastname
      }
    }
  }
`

const formatData = (medications) => (
  _.map(medications, (medication, i) => ({
    key: `${i}`,
    doseName: _.get(medication, 'dose.name'),
    remindAt: moment(_.get(medication, 'reminder.remindAt')).format('DD/MM/YYYY HH:mm'),
    eaten: _.get(medication, 'eaten')
  }))
)

export const MedicationList = ({ data, match }) => {
  console.log('match:', match)
  console.log('data:', data)
  const patientId = _.get(match, 'params.patientId')
  const medications = _.get(data, 'data.medications.medications')
  const displayName = _.get(data, 'data.medications.displayName')
  const displayImage = _.get(data, 'data.medications.displayImage')
  const patient = _.get(data, 'data.medications.patient')
  return (
    <div>
      <Helmet>
        <title>ประวัติการทานยา</title>
      </Helmet>
      {patientId &&
        <div className="patient-info">
          <img src={displayImage || 'https://assets17.sigaccess.org/images/user_icon.png'} />
          <h2>{patient.firstname} {patient.lastname}</h2>
          <h4>{displayName}</h4>
        </div>
      }
      <Table
        style={{ backgroundColor: '#eee' }}
        columns={columns}
        dataSource={formatData(medications, data)}
        pagination={false}
      />
    </div>
  )
}

export default withData(query)(MedicationList)



// WEBPACK FOOTER //
// ./src/MedicationList/MedicationList.js